import { defineMessages } from 'react-intl';

export const chatMessages = defineMessages({
  // action to close inbox
  closeInbox: { defaultMessage: 'Close the discussion', id: 'tKTlvp' },
  reduceInbox: { defaultMessage: 'Minimize the discussion', id: 'dJGQVI' },
  openInbox: { defaultMessage: 'Open the discussion', id: 'sIRu4m' },
  createInbox: { defaultMessage: 'Create the conversation', id: '5t3Bw5' },
  addFriend: { defaultMessage: 'Add friends to the discussion', id: 'DjXxPM' },
  addOneFriendPlaceholder: { defaultMessage: 'Add a friend', id: 'zCGuyL' },
  newInboxSubTitleFallback: { defaultMessage: 'new conversation', id: 'VwvT4s' },
  noInboxYet: { defaultMessage: 'you have not yet exchanged', id: 'clqOoF' },
  inboxTitle: { defaultMessage: 'Discussion', id: '20bImY' },
  newInboxTitle: { defaultMessage: 'New message', id: 'BOGA9j' },
  to: { defaultMessage: 'To:', id: 'Seu2ON' },
  invalidChatInputPlacholder: { defaultMessage: 'Exchange unavailable', id: 'iyr7WG' },
  chatInputPlacholder: { defaultMessage: 'Write a message here', id: 'weaZnC' },
  noFriends: { defaultMessage: 'No matching friend', id: 'k6bDdH' },
});
